export class FlowRun {
    environment?: string;
    _id?: string;
    flowName?:string;
    flowDisplayName?: string;
    name?: string;
    startTime: Date;
    endTime: Date;
    status: string;
    triggerName?: string;
    type?: string = "run";
    triggerData?: any;
    triggerTest = false;
    raw?: any;
    error?: any;

    constructor(init?: any){
        if (init) {
            this.initialize(init);
        }
    }

    initialize(item: any) {
        if (item?.properties?.object){
            // via event
            this._id = this.name = item.name || item.properties.object.flowRunSequenceId;
            this.flowName = item.properties.object.flowName;
            this.status = item.properties.object.status;
            this.startTime = (item.properties.object.timestamp)? new Date(item.properties.object.timestamp): null;
            this.endTime = (item.properties.object.timestamp && item.properties.object.durationInMilliseconds)? new Date(item.properties.object.timestamp) + item.properties.object.durationInMilliseconds:null;
            this.raw = item;
            return;
        }

        if (item?.__typename == "Run"){
            // via flow studio server
            this._id = this.name = item.name;
            this.startTime = item.startTime ? new Date(item.startTime): null;
            this.endTime = item.endTime ? new Date(item.endTime): null;
            this.environment = item.environment;
            this.flowName = item.flowName;
            this.flowDisplayName = item.flowDisplayName;
            this.status = item.status;
            this.triggerName = item.triggerName;
            return;
        }

        if (item?.name) {
            // via run-api
            this._id = this.name = item.name;
            // this.flowName = item.properties.object.flowName;
            this.startTime = item.properties.startTime ? new Date(item.properties.startTime) : null;
            this.endTime = item.properties.endTime? new Date(item.properties.endTime): null;
            this.triggerName = null;
            if (item.properties.trigger) {
                this.triggerName = item.properties.trigger.name;
                if (item.properties.trigger.correlation && item.properties.trigger.correlation.clientKeywords) {
                    let keywords = item.properties.trigger.correlation.clientKeywords;
                    item.triggerTest = (keywords.find(k=>k=="testFlow"));
                }
            }
            this.status = item.triggerTest ? `Test ${item.properties.status}` : item.properties.status;
            this.raw = item;

            if (this.triggerName == 'Recurrence') {
                this.triggerData = [item.properties.trigger];
            }

            return;
        }

        //this.environment = item.properties.environment.name;
    }

    get duration(){
        return this.endTime ? this.endTime.getTime() - this.startTime.getTime() : null;
    }

    get durationString() {
        var diff = this.duration;
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        diff -=  days * (1000 * 60 * 60 * 24);

        var hours = Math.floor(diff / (1000 * 60 * 60));
        diff -= hours * (1000 * 60 * 60);

        var mins = Math.floor(diff / (1000 * 60));
        diff -= mins * (1000 * 60);

        var seconds = diff/1000;// Math.floor(diff / (1000));
        //diff -= seconds * (1000);

        var results = [];
        if (days) results.push(`${days}d`);
        if (hours) results.push(`${hours}h`);
        if (mins) results.push(`${mins}m`);
        if (seconds) results.push(`${seconds}s`);
        //if (diff) results.push(`${diff}ms`);
        return results.join(' ');
        //document.write(days + " days, " + hours + " hours, " + mins + " minutes, " + seconds + " seconds");
    }

    get runUrl(): string {
      return `https://flow.microsoft.com/manage/environments/${this.environment}/flows/${this.flowName}/runs/${this.name}`;
    }

    get triggerDataValue() : string {
      if (!this.triggerData) {
        return '';
      }
      return JSON.stringify(this.triggerData);
    }

    get triggerValue() : string {
        if (!this.triggerData) {
            return '';
        }
        if (this.triggerData.length == 2) {
            if(typeof this.triggerData[0] == 'object' && this.triggerData[0].body) {
                if (this.triggerData[0].body.ID) {
                    return `${this.triggerData[0].body.ID}`;
                }
            }
            if(typeof this.triggerData[1] == 'object' && this.triggerData[1].body) {
                if (this.triggerData[1].body.ID) {
                    return `${this.triggerData[1].body.ID}`;
                }
                if (this.triggerData[1].body.ItemInternalId) {
                    return `${this.triggerData[1].body.ItemInternalId}`;
                }
            }
        }
        if (this.triggerData.length == 1) {
            if (typeof this.triggerData[0] == 'object' && this.triggerData[0].body) {

                const [match] = ['ID', 'id', 'Id'].map(key => {
                    return this.triggerData[0].body[key];
                }).filter(value=>value);
                if (match) {
                    return match;
                }
                // if (this.triggerData[0].body.ID) {
                //     return ''+this.triggerData[0].body.ID;
                // }
                // if (this.triggerData[0].body.id) {
                //     return ''+this.triggerData[0].body.id;
                // }
                // if (this.triggerData[0].body.Id) {
                //     return ''+this.triggerData[0].body.Id;
                // }
                if (this.triggerData[0].body.value && this.triggerData[0].body.value.length > 0 && this.triggerData[0].body.value[0].ID) {
                    return `${this.triggerData[0].body.value[0].ID}`;
                }
            }
        }
        if (this.triggerData.length == 2 && (typeof this.triggerData[1] == 'object') && this.triggerData[1].body) {

            const [match] = ['ID', 'id', 'Id', 'TweetId'].map(key => {
                return this.triggerData[1].body[key];
            }).filter(value=>value);
            if (match) {
                return match;
            }

            // twitter
            // if ('TweetText' in ) {
            //     return this.triggerData[1].body.TweetText;
            // }
        }
        if (this.triggerName == "manual" && this.triggerData.length == 1 && typeof this.triggerData[0] == 'object' && this.triggerData[0].body) {
            // request, flow button, powerapps
            return JSON.stringify(this.triggerData[0].body);
        }
        if (this.triggerData.length == 2 && (typeof this.triggerData[1] == 'object') && this.triggerData[1].body && this.triggerData[1].body.resourceData) {
            // form
            return this.triggerData[1].body.resourceData.responseId;
        }
        return '...';
    }

    get triggerText() : string {
        if (!this.triggerData) {
            return '';
        }
        if (this.triggerData.length == 2) {

            if(typeof this.triggerData[0] == 'object' && this.triggerData[0].body) {
                let triggerBody = this.triggerData[0].body;
                if (triggerBody.Title) {
                    return `${triggerBody.Title}`;
                }
            }
            if(typeof this.triggerData[1] == 'object' && this.triggerData[1].body) {
                let triggerBody = this.triggerData[1].body;
                if ('Title' in triggerBody) {
                    return `${triggerBody.Title}`;
                }
                if ('{Identifier}' in triggerBody) {
                    return `${this.decode(triggerBody['{Identifier}'])}`
                }
                if ('ItemInternalId' in triggerBody) {
                    //return `${triggerBody.ItemInternalId}`;

                    // attempt to find title or name for dynamics/cds

                    let props = Object.keys(triggerBody);
                    let modelKey = props.find(p=> (p.endsWith('_title')));
                    if (modelKey) {
                        return `${triggerBody[modelKey]}`
                    }
                    modelKey = props.find(p=> (p.endsWith('_name')));
                    if (modelKey) {
                        return `${triggerBody[modelKey]}`
                    }

                    // can't find - give up for now.
                }
                // if ('Subject' in triggerBody) {
                //     return `${triggerBody.Subject}`;
                // }
                // if ('TweetText' in triggerBody) {
                //     return `${triggerBody.TweetText}`;
                // }
                const [match] = ['Subject', 'subject', 'TweetText'].map(key => {
                    return triggerBody[key];
                }).filter(value=>value);
                if (match) {
                    return match;
                }

                // if (this.triggerData[1].body.resourceData && this.triggerData[1].body.resourceData.responseId) {
                //     // Forms
                //     return `${this.triggerData[1].body.resourceData.responseId}`;
                // }
            }
        }
        if (this.triggerData.length == 1) {
            if (typeof this.triggerData[0] == 'object' && this.triggerData[0].body) {
                let triggerBody = this.triggerData[0].body;
                if (triggerBody.Title) {
                    return `${triggerBody.Title}`;
                }
                if (triggerBody['{Identifier}']) {
                    return `${this.decode(triggerBody['{Identifier}'])}`
                }
                if (triggerBody.value && triggerBody.value.length > 0) {
                    if (triggerBody.value[0].Title) {
                        return `${triggerBody.value[0].Title}`;
                    }
                    if (triggerBody.value[0]['{Identifier}']) {
                        return `${this.decode(triggerBody.value[0]['{Identifier}'])}`;
                    }
                }
                return JSON.stringify(this.triggerData[0].body);
            }
        }
        return '...';
    }

    decode(s): string {
        if (s === null) {
            return null;
        }
        return decodeURIComponent(decodeURIComponent(s));
    }

    get actions() : string[] {
        var actions = ['Resubmit', 'Cancel', /* 'Delete', */ 'Get Latest Runs'];
        actions.push('Get More Runs (slow)');

        //if (this.status == 'Failed') {
        actions.push('List Run Actions');
        actions.push('Run Timeline');
        actions.push('Run Gantt');
        //}
        actions.push('Export Excel');
        return actions;
    }

    get adminActions() : string[] {
        var actions = ['Resubmit', 'Cancel', 'Get Latest Runs'];
        actions.push('Get More Runs');
        actions.push('Get All Runs (slow)');

        //if (this.status == 'Failed') {
        actions.push('List Run Actions');
        //}
        actions.push('Export Excel');
        return actions;
    }

}

